// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Share+Tech+Mono&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish:wght@200..1000&family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Share+Tech+Mono&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Prevent horizontal overflow */
html, body {
  margin: 0; /* Remove default body margin */
  padding: 0; /* Remove default body padding */
  overflow-x: hidden; /* Hide horizontal overflow */
  width: 100%;
}

/* Ensure all elements respect the width of the viewport */
* {
  box-sizing: border-box; /* Include padding and border in width calculation */
}

.hero {
  width: 100%; /* Ensure the .hero section spans the full width */
}

.container {
  max-width: 100%; /* Prevent containers from exceeding viewport width */
  overflow: hidden; /* Hide any internal overflow */
}

.docHub {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.test {
  color: red;
}

.header {
  background-color: #1c1c1f;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 16px 64px;
  color: #fff;
  font: 400 16px mulish, sans-serif;
}

.logoContainer {
  display: flex;
  align-items: center;
  gap: 40px;
}

.logo {
  width: 106px;
  height: auto;
}

.navigation {
  display: flex;
  gap: 16px;
}

.navLink {
  color: #fff;
  text-decoration: none;
  padding: 8px 16px;
}

.headerActions {
  display: flex;
  align-items: center;
  gap: 24px;
}

.demoButton {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #bdf78a;
  color: #1e1e22;
  font-weight: 700;
  text-transform: uppercase;
  border: none;
  border-radius: 60px;
  padding: 12px 16px;
  cursor: pointer;
}

.buttonIcon {
  width: 18px;
  height: 10px;
}

.themeToggle {
  display: flex;
  align-items: center;
  gap: 7px;
}

.themeIcon {
  width: 16px;
  height: 16px;
}

.themeText {
  color: #fff;
}

.hero {
  background-color: #3e4042;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 496px;
  /* Background properties for the repeating pattern */
  background-repeat: repeat; /* Ensure the pattern repeats */
  background-size: auto;
  display: flex;
  background-position: center; /* Adjust vertically or horizontally */
}

.heroContent {
  max-width: 100%;
  padding: 0 37px;
}

.heroTitle {
  color: var(--text-inverted-default, #FFF);
  text-align: center;
  width: 372px;
  height: 42px;
  gap: 28px;
  opacity: 0px;

  /* Correct usage of Mulish font */
  font-family: Mulish, sans-serif;
  font-size: 60px;
  font-style: normal;
  font-weight: 700 !important; /* Ensuring bold weight is applied */
  /*line-height: 90px; /* 150% */
}


/* Typing animation */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* Blinking cursor animation */
@keyframes blink {
  50% {
    border-color: transparent;
  }
}


.heroDescription {
  color: #fff;
  font-size: 24px;
  font-family: Mulish, sans-serif;
}

.searchForm {
  position: relative;
  width: 100%;
  max-width: 539px;
  margin-top: 40px;
}

.searchInput {
  width: 100%;
  padding: 10px 10px;
  border-radius: 50px;
  border: none;
  background-color: #1e1e22;
  color: #fff;
  font: 16px Mulish, sans-serif;
}

.searchButton {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 42px;
  background-color: #bdf78a;
  border: none;
  border-radius: 60px;
  cursor: pointer;
}

.searchIconAI {
  position: absolute;
  left: 16px; /* Position the icon inside the input */
  width: 24px;
  height: 39px; /* Adjust size of the icon */
  opacity: 80%;
  pointer-events: none; /* Prevent the icon from intercepting clicks */
}

.searchIcon {
  width: 16px;
  height: 16px;
}

.popularSearches {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.6);
  font: 12px Mulish, sans-serif;
}

.searchTag {
  background-color: rgba(30, 30, 34, 0.5);
  border: none;
  border-radius: 60px;
  padding: 4px 8px;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.productCards {
  display: flex;
  margin-top: -165px;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

/* Adjust for tablets and medium devices */
@media (max-width: 1024px) {
  .productCards {
    gap: 16px; /* Reduce gap between items */
    margin-top: -130px; /* Adjust margin for smaller screens */
  }
}

/* Adjust for mobile devices */
@media (max-width: 768px) {
  .productCards {
    flex-direction: column; /* Stack items vertically */
    gap: 12px; /* Smaller gap */
    margin-top: -130px; /* Further reduced margin */
  }
}

/* Optional for very small screens */
@media (max-width: 480px) {
  .productCards {
    gap: 8px; /* Compact gap */
    margin-top: -100px; /* Minimal margin for small devices */
  }
}


.productCard {
  background-color: rgba(44, 46, 48, 1);
  border-radius: 32px;
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 23px;
  max-width: 528px;
  flex: 1 0 0;
  align-self: stretch;
  height: 140px;
  max-width: 430px;
  gap: 23px;
  opacity: 0px;
  font-family: Mulish, sans-serif;
  transition: border-color 0.3s, transform 0.3s; /* Smooth transition for hover effects */
  border: 2px solid transparent; /* Default border */
}

.productCard:hover {
  border-color: #bdf78a; /* Change border to red on hover */
  cursor: pointer; /* Show pointer cursor */
}

.productIcon {
  height: 70px;
  width: 80px;
}

.productInfo {
  display: flex;
  flex-direction: column;
}

.productCategory {
  color: #bdf78a;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.26px;
  text-transform: uppercase;
}

.productTitle {
  color: #fff;
  font-size: 21px;
  font-weight: 600;
  margin-top: 6px;
}

.productDescription {
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  margin-top: 6px;
}

.gettingStarted {
  background-color: #fff;
  padding: 160px 64px 96px;
}

.sectionTitle {
  color: #1e1e22;
  font-size: 40px;
  font-weight: 800;
  line-height: 36px;
  text-align: center;
}

.sectionSubtitle {
  display: block;
  font-size: 24px;
  font-weight: 600;
  margin-top: 10px;
}

.stepsContainer {
  display: flex;
  gap: 24px;
  margin-top: 64px;
}

.stepCard {
  background-color: #e7e8ea;
  border-radius: 41px;
  padding: 24px;
  flex: 1;
}

.stepHeader {
  display: flex;
  align-items: center;
  gap: 24px;
}

.stepNumber {
  background-color: #1c1c1f;
  color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
}

.stepTitle {
  color: #1c1c1f;
  font-size: 24px;
  font-weight: 700;
}

.stepContent {
  margin-top: 16px;
  padding-left: 70px;
}

.stepDescription {
  color: rgba(28, 28, 31, 0.9);
  font-size: 16px;
  line-height: 21px;
}

.stepActions {
  display: flex;
  gap: 40px;
  margin-top: 24px;
}

.actionButton {
  background: none;
  border: none;
  color: #1c1c1f;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}

.resourcesSection {
  background-color: #3E4042;
  display: flex;
  padding: 80px 64px;
  justify-content: center;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
}

/* Adjust for tablets and medium devices */
@media (max-width: 1024px) {
  .resourcesSection {
    padding: 60px 32px; /* Reduce padding for smaller screens */
    gap: 32px; /* Reduce space between items */
  }
}

/* Adjust for mobile devices */
@media (max-width: 768px) {
  .resourcesSection {
    flex-direction: column; /* Stack items vertically */
    padding: 40px 20px; /* Further reduce padding */
    gap: 20px; /* Smaller gap for mobile */
    align-items: center; /* Center-align content */
  }
}

/* Optional for very small screens */
@media (max-width: 480px) {
  .resourcesSection {
    padding: 20px 10px; /* Minimal padding */
    gap: 12px; /* Compact gap */
  }
}


.resourcesHeader {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}

.resourcesTitle {
  color: #fff;
  font-size: 40px;
  font-weight: 800;
  line-height: 48px;
}

.learnMoreButton {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #bdf78a;
  border: none;
  border-radius: 60px;
  padding: 12px 16px;
  color: #1e1e22;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}

.resourcesGrid {
  display: flex;
  gap: 24px;
}

.resourceCard {
  background-color: #1E1E22;
  border-radius: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 36px 30px;
  width: 180px;
  height: 180px;
  box-sizing: border-box;
  transition: border-color 0.3s, transform 0.3s ease; /* Smooth transition for hover effects */
  border: 2px solid transparent; /* Default border */
}

.resourceCard:hover {
  border-color: #bdf78a; /* Green border on hover */
  transform: translateY(-5px); /* Slight lift on hover */
}

.resourceCard a {
  text-decoration: none; /* Remove underline for links */
  color: inherit; /* Inherit text color */
  display: flex; /* Ensure content stays inside the link */
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.resourceIcon {
  width: 70px;
  height: 70px;
}

.resourceTitle {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  padding-top: 15px;
}

.featureGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  gap: 32px;
  padding: 96px 64px;
  margin-top: -86px;
}

/* Adjust for tablets and smaller devices */
@media (max-width: 1024px) {
  .featureGrid {
    grid-template-columns: repeat(2, 1fr); /* 2 columns */
    padding: 64px 32px; /* Reduce padding */
    gap: 24px; /* Smaller gap */
  }
}

/* Adjust for mobile devices */
@media (max-width: 768px) {
  .featureGrid {
    grid-template-columns: 1fr; /* Single column */
    padding: 48px 16px; /* Further reduced padding */
    gap: 16px; /* Even smaller gap */
  }
}

/* Optional for very small screens */
@media (max-width: 480px) {
  .featureGrid {
    padding: 32px 8px; /* Minimal padding for compact layout */
    gap: 8px; /* Compact gap */
  }
}




.featureCard {
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Space between content blocks */
  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transform and shadow */
  overflow: hidden; /* Prevent content from overflowing during scaling */
}


/* Dark Mode */
html.dark {
  .featureCard {
  background-color: #121217;
  color: #fff;
  }
  .featureDescription {
    color: #FFF;
  }
  .featureGrid {
    background-color: #121217;
  }
  .heroTitle {
    color: #FFFFFF;
  }
  .learnMoreButton {
    color: #1e1e22;
  }
  .resourcesTitle {
    color: #FFF;
  }
}

.featureCard:hover {
  transform: scale(1.05); /* Slightly increase the size of the card */
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */
}

.arrowIcon {
  display: none;
  width: 16px; /* Adjust size to match the design */
  height: 16px;
  margin-left: 4px; /* Optional: Adds extra space if needed */
  vertical-align: middle; /* Ensures proper alignment with the text */
  transition: transform 0.2s ease; /* Adds a smooth effect on hover if desired */
}

.featureCard:hover .arrowIcon {
  display: block; /* Show the arrow icon when the card is hovered */
}

.featureHeader {
  display: flex;
  align-items: center; /* Align icon and title vertically */
  gap: 12px; /* Space between icon and title */
  margin-bottom: 16px;
}

.featureIcon {
  background-color: #e7e8ea;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.featureTitle {
  color: #1c1c1f;
  font-size: 18px;
  font-weight: 700;
  display: inline-flex; /* Ensures the title and icon align horizontally */
  align-items: center; /* Aligns the icon with the text */
  gap: 8px; /* Adds space between the title and the icon */
  margin: 0;
}

.featureDescription {
  color: #1c1c1f;
  font-size: 14px;
 /* margin-top: 8px; */
  padding-left: 52px;
}

.footer {
  background-color: #1e1e22;
  padding: 88px 64px 16px;
}

.footerContent {
  display: flex;
  justify-content: space-between;
}

.footerColumn {
  display: flex;
  flex-direction: column;
}

.footerColumnTitle {
  color: #bdf78a;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.26px;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.footerLinkList {
  list-style-type: none;
  padding: 0;
}

.footerLink {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  line-height: 2;
}

.socialLinks {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.socialLink {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}

.socialIcon {
  width: 17px;
  height: 17px;
}

.footerDivider {
  background-color: #bdf78a;
  height: 1px;
  margin: 48px 0;
}

.footerBottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footerLogo {
  width: 106px;
}

.copyright {
  color: #fff;
  font-size: 16px;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 991px) {

  .containerFluid {
    width: 100%;
  }

  .header {
    padding: 16px 20px;
  }

  .hero {
    padding: 100px 20px;
  }

  .heroTitle {
    font-size: 40px;
  }

  .productCards {
    flex-direction: column;
    padding: 0 20px;
  }

  .gettingStarted {
    padding: 100px 20px;
  }

  .stepsContainer {
    flex-direction: column;
  }

  .resourcesSection {
    padding: 100px 20px;
  }

  .resourcesGrid {
    flex-wrap: wrap;
    justify-content: center;
  }

  .featureGrid {
    padding: 60px 20px;
  }



  .footer {
    padding: 60px 20px 16px;
  }

  .footerContent {
    flex-wrap: wrap;
    gap: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./static/styles.css"],"names":[],"mappings":"AAIA,gCAAgC;AAChC;EACE,SAAS,EAAE,+BAA+B;EAC1C,UAAU,EAAE,gCAAgC;EAC5C,kBAAkB,EAAE,6BAA6B;EACjD,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB,EAAE,oDAAoD;AAC9E;;AAEA;EACE,WAAW,EAAE,kDAAkD;AACjE;;AAEA;EACE,eAAe,EAAE,qDAAqD;EACtE,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,oDAAoD;EACpD,yBAAyB,EAAE,+BAA+B;EAC1D,qBAAqB;EACrB,aAAa;EACb,2BAA2B,EAAE,sCAAsC;AACrE;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,YAAY;;EAEZ,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,2BAA2B,EAAE,oCAAoC;EACjE,8BAA8B;AAChC;;;AAGA,qBAAqB;AACrB;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,uCAAuC;EACnD,WAAW;EACX,YAAY,EAAE,4BAA4B;EAC1C,YAAY;EACZ,oBAAoB,EAAE,8CAA8C;AACtE;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE;IACE,SAAS,EAAE,6BAA6B;IACxC,kBAAkB,EAAE,sCAAsC;EAC5D;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,SAAS,EAAE,gBAAgB;IAC3B,kBAAkB,EAAE,2BAA2B;EACjD;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,QAAQ,EAAE,gBAAgB;IAC1B,kBAAkB,EAAE,qCAAqC;EAC3D;AACF;;;AAGA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,+BAA+B;EAC/B,6CAA6C,EAAE,wCAAwC;EACvF,6BAA6B,EAAE,mBAAmB;AACpD;;AAEA;EACE,qBAAqB,EAAE,kCAAkC;EACzD,eAAe,EAAE,wBAAwB;AAC3C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE;IACE,kBAAkB,EAAE,uCAAuC;IAC3D,SAAS,EAAE,+BAA+B;EAC5C;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,kBAAkB,EAAE,2BAA2B;IAC/C,SAAS,EAAE,2BAA2B;IACtC,mBAAmB,EAAE,yBAAyB;EAChD;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,kBAAkB,EAAE,oBAAoB;IACxC,SAAS,EAAE,gBAAgB;EAC7B;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAkD,EAAE,wCAAwC;EAC5F,6BAA6B,EAAE,mBAAmB;AACpD;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;EACjD,2BAA2B,EAAE,yBAAyB;AACxD;;AAEA;EACE,qBAAqB,EAAE,+BAA+B;EACtD,cAAc,EAAE,uBAAuB;EACvC,aAAa,EAAE,yCAAyC;EACxD,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE;IACE,qCAAqC,EAAE,cAAc;IACrD,kBAAkB,EAAE,mBAAmB;IACvC,SAAS,EAAE,gBAAgB;EAC7B;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,0BAA0B,EAAE,kBAAkB;IAC9C,kBAAkB,EAAE,4BAA4B;IAChD,SAAS,EAAE,qBAAqB;EAClC;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,QAAQ,EAAE,gBAAgB;EAC5B;AACF;;;;;AAKA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAE,iCAAiC;EACjE,qDAAqD,EAAE,gCAAgC;EACvF,gBAAgB,EAAE,oDAAoD;AACxE;;;AAGA,cAAc;AACd;EACE;EACA,yBAAyB;EACzB,WAAW;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,sBAAsB,EAAE,2CAA2C;EACnE,2CAA2C,EAAE,wBAAwB;AACvE;;AAEA;EACE,aAAa;EACb,WAAW,EAAE,oCAAoC;EACjD,YAAY;EACZ,gBAAgB,EAAE,yCAAyC;EAC3D,sBAAsB,EAAE,2CAA2C;EACnE,+BAA+B,EAAE,6CAA6C;AAChF;;AAEA;EACE,cAAc,EAAE,iDAAiD;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,oCAAoC;EACzD,SAAS,EAAE,iCAAiC;EAC5C,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB,EAAE,kDAAkD;EACxE,mBAAmB,EAAE,kCAAkC;EACvD,QAAQ,EAAE,8CAA8C;EACxD,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;CAChB,qBAAqB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;;;EAIA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&family=Share+Tech+Mono&display=swap');\n\n@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@200..1000&family=Poppins:wght@100;200;300;400;500;600;700;800;900&family=Share+Tech+Mono&display=swap');\n\n/* Prevent horizontal overflow */\nhtml, body {\n  margin: 0; /* Remove default body margin */\n  padding: 0; /* Remove default body padding */\n  overflow-x: hidden; /* Hide horizontal overflow */\n  width: 100%;\n}\n\n/* Ensure all elements respect the width of the viewport */\n* {\n  box-sizing: border-box; /* Include padding and border in width calculation */\n}\n\n.hero {\n  width: 100%; /* Ensure the .hero section spans the full width */\n}\n\n.container {\n  max-width: 100%; /* Prevent containers from exceeding viewport width */\n  overflow: hidden; /* Hide any internal overflow */\n}\n\n.docHub {\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.test {\n  color: red;\n}\n\n.header {\n  background-color: #1c1c1f;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 64px;\n  color: #fff;\n  font: 400 16px mulish, sans-serif;\n}\n\n.logoContainer {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n}\n\n.logo {\n  width: 106px;\n  height: auto;\n}\n\n.navigation {\n  display: flex;\n  gap: 16px;\n}\n\n.navLink {\n  color: #fff;\n  text-decoration: none;\n  padding: 8px 16px;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.demoButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #bdf78a;\n  color: #1e1e22;\n  font-weight: 700;\n  text-transform: uppercase;\n  border: none;\n  border-radius: 60px;\n  padding: 12px 16px;\n  cursor: pointer;\n}\n\n.buttonIcon {\n  width: 18px;\n  height: 10px;\n}\n\n.themeToggle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.themeIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.themeText {\n  color: #fff;\n}\n\n.hero {\n  background-color: #3e4042;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  height: 496px;\n  /* Background properties for the repeating pattern */\n  background-repeat: repeat; /* Ensure the pattern repeats */\n  background-size: auto;\n  display: flex;\n  background-position: center; /* Adjust vertically or horizontally */\n}\n\n.heroContent {\n  max-width: 100%;\n  padding: 0 37px;\n}\n\n.heroTitle {\n  color: var(--text-inverted-default, #FFF);\n  text-align: center;\n  width: 372px;\n  height: 42px;\n  gap: 28px;\n  opacity: 0px;\n\n  /* Correct usage of Mulish font */\n  font-family: Mulish, sans-serif;\n  font-size: 60px;\n  font-style: normal;\n  font-weight: 700 !important; /* Ensuring bold weight is applied */\n  /*line-height: 90px; /* 150% */\n}\n\n\n/* Typing animation */\n@keyframes typing {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* Blinking cursor animation */\n@keyframes blink {\n  50% {\n    border-color: transparent;\n  }\n}\n\n\n.heroDescription {\n  color: #fff;\n  font-size: 24px;\n  font-family: Mulish, sans-serif;\n}\n\n.searchForm {\n  position: relative;\n  width: 100%;\n  max-width: 539px;\n  margin-top: 40px;\n}\n\n.searchInput {\n  width: 100%;\n  padding: 10px 10px;\n  border-radius: 50px;\n  border: none;\n  background-color: #1e1e22;\n  color: #fff;\n  font: 16px Mulish, sans-serif;\n}\n\n.searchButton {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 42px;\n  background-color: #bdf78a;\n  border: none;\n  border-radius: 60px;\n  cursor: pointer;\n}\n\n.searchIconAI {\n  position: absolute;\n  left: 16px; /* Position the icon inside the input */\n  width: 24px;\n  height: 39px; /* Adjust size of the icon */\n  opacity: 80%;\n  pointer-events: none; /* Prevent the icon from intercepting clicks */\n}\n\n.searchIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.popularSearches {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n  color: rgba(255, 255, 255, 0.6);\n  font: 12px Mulish, sans-serif;\n}\n\n.searchTag {\n  background-color: rgba(30, 30, 34, 0.5);\n  border: none;\n  border-radius: 60px;\n  padding: 4px 8px;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.productCards {\n  display: flex;\n  margin-top: -165px;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n\n/* Adjust for tablets and medium devices */\n@media (max-width: 1024px) {\n  .productCards {\n    gap: 16px; /* Reduce gap between items */\n    margin-top: -130px; /* Adjust margin for smaller screens */\n  }\n}\n\n/* Adjust for mobile devices */\n@media (max-width: 768px) {\n  .productCards {\n    flex-direction: column; /* Stack items vertically */\n    gap: 12px; /* Smaller gap */\n    margin-top: -130px; /* Further reduced margin */\n  }\n}\n\n/* Optional for very small screens */\n@media (max-width: 480px) {\n  .productCards {\n    gap: 8px; /* Compact gap */\n    margin-top: -100px; /* Minimal margin for small devices */\n  }\n}\n\n\n.productCard {\n  background-color: rgba(44, 46, 48, 1);\n  border-radius: 32px;\n  display: flex;\n  align-items: center;\n  padding: 20px;\n  gap: 23px;\n  max-width: 528px;\n  flex: 1 0 0;\n  align-self: stretch;\n  height: 140px;\n  max-width: 430px;\n  gap: 23px;\n  opacity: 0px;\n  font-family: Mulish, sans-serif;\n  transition: border-color 0.3s, transform 0.3s; /* Smooth transition for hover effects */\n  border: 2px solid transparent; /* Default border */\n}\n\n.productCard:hover {\n  border-color: #bdf78a; /* Change border to red on hover */\n  cursor: pointer; /* Show pointer cursor */\n}\n\n.productIcon {\n  height: 70px;\n  width: 80px;\n}\n\n.productInfo {\n  display: flex;\n  flex-direction: column;\n}\n\n.productCategory {\n  color: #bdf78a;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 1.26px;\n  text-transform: uppercase;\n}\n\n.productTitle {\n  color: #fff;\n  font-size: 21px;\n  font-weight: 600;\n  margin-top: 6px;\n}\n\n.productDescription {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 15px;\n  margin-top: 6px;\n}\n\n.gettingStarted {\n  background-color: #fff;\n  padding: 160px 64px 96px;\n}\n\n.sectionTitle {\n  color: #1e1e22;\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 36px;\n  text-align: center;\n}\n\n.sectionSubtitle {\n  display: block;\n  font-size: 24px;\n  font-weight: 600;\n  margin-top: 10px;\n}\n\n.stepsContainer {\n  display: flex;\n  gap: 24px;\n  margin-top: 64px;\n}\n\n.stepCard {\n  background-color: #e7e8ea;\n  border-radius: 41px;\n  padding: 24px;\n  flex: 1;\n}\n\n.stepHeader {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.stepNumber {\n  background-color: #1c1c1f;\n  color: #fff;\n  width: 48px;\n  height: 48px;\n  border-radius: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.stepTitle {\n  color: #1c1c1f;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.stepContent {\n  margin-top: 16px;\n  padding-left: 70px;\n}\n\n.stepDescription {\n  color: rgba(28, 28, 31, 0.9);\n  font-size: 16px;\n  line-height: 21px;\n}\n\n.stepActions {\n  display: flex;\n  gap: 40px;\n  margin-top: 24px;\n}\n\n.actionButton {\n  background: none;\n  border: none;\n  color: #1c1c1f;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.resourcesSection {\n  background-color: #3E4042;\n  display: flex;\n  padding: 80px 64px;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 64px;\n  align-self: stretch;\n}\n\n/* Adjust for tablets and medium devices */\n@media (max-width: 1024px) {\n  .resourcesSection {\n    padding: 60px 32px; /* Reduce padding for smaller screens */\n    gap: 32px; /* Reduce space between items */\n  }\n}\n\n/* Adjust for mobile devices */\n@media (max-width: 768px) {\n  .resourcesSection {\n    flex-direction: column; /* Stack items vertically */\n    padding: 40px 20px; /* Further reduce padding */\n    gap: 20px; /* Smaller gap for mobile */\n    align-items: center; /* Center-align content */\n  }\n}\n\n/* Optional for very small screens */\n@media (max-width: 480px) {\n  .resourcesSection {\n    padding: 20px 10px; /* Minimal padding */\n    gap: 12px; /* Compact gap */\n  }\n}\n\n\n.resourcesHeader {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n}\n\n.resourcesTitle {\n  color: #fff;\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 48px;\n}\n\n.learnMoreButton {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #bdf78a;\n  border: none;\n  border-radius: 60px;\n  padding: 12px 16px;\n  color: #1e1e22;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.resourcesGrid {\n  display: flex;\n  gap: 24px;\n}\n\n.resourceCard {\n  background-color: #1E1E22;\n  border-radius: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 36px 30px;\n  width: 180px;\n  height: 180px;\n  box-sizing: border-box;\n  transition: border-color 0.3s, transform 0.3s ease; /* Smooth transition for hover effects */\n  border: 2px solid transparent; /* Default border */\n}\n\n.resourceCard:hover {\n  border-color: #bdf78a; /* Green border on hover */\n  transform: translateY(-5px); /* Slight lift on hover */\n}\n\n.resourceCard a {\n  text-decoration: none; /* Remove underline for links */\n  color: inherit; /* Inherit text color */\n  display: flex; /* Ensure content stays inside the link */\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n}\n\n.resourceIcon {\n  width: 70px;\n  height: 70px;\n}\n\n.resourceTitle {\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  text-align: center;\n  padding-top: 15px;\n}\n\n.featureGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* 3 columns */\n  gap: 32px;\n  padding: 96px 64px;\n  margin-top: -86px;\n}\n\n/* Adjust for tablets and smaller devices */\n@media (max-width: 1024px) {\n  .featureGrid {\n    grid-template-columns: repeat(2, 1fr); /* 2 columns */\n    padding: 64px 32px; /* Reduce padding */\n    gap: 24px; /* Smaller gap */\n  }\n}\n\n/* Adjust for mobile devices */\n@media (max-width: 768px) {\n  .featureGrid {\n    grid-template-columns: 1fr; /* Single column */\n    padding: 48px 16px; /* Further reduced padding */\n    gap: 16px; /* Even smaller gap */\n  }\n}\n\n/* Optional for very small screens */\n@media (max-width: 480px) {\n  .featureGrid {\n    padding: 32px 8px; /* Minimal padding for compact layout */\n    gap: 8px; /* Compact gap */\n  }\n}\n\n\n\n\n.featureCard {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 24px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between; /* Space between content blocks */\n  transition: transform 0.3s ease, box-shadow 0.3s ease; /* Smooth transform and shadow */\n  overflow: hidden; /* Prevent content from overflowing during scaling */\n}\n\n\n/* Dark Mode */\nhtml.dark {\n  .featureCard {\n  background-color: #121217;\n  color: #fff;\n  }\n  .featureDescription {\n    color: #FFF;\n  }\n  .featureGrid {\n    background-color: #121217;\n  }\n  .heroTitle {\n    color: #FFFFFF;\n  }\n  .learnMoreButton {\n    color: #1e1e22;\n  }\n  .resourcesTitle {\n    color: #FFF;\n  }\n}\n\n.featureCard:hover {\n  transform: scale(1.05); /* Slightly increase the size of the card */\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); /* Add a subtle shadow */\n}\n\n.arrowIcon {\n  display: none;\n  width: 16px; /* Adjust size to match the design */\n  height: 16px;\n  margin-left: 4px; /* Optional: Adds extra space if needed */\n  vertical-align: middle; /* Ensures proper alignment with the text */\n  transition: transform 0.2s ease; /* Adds a smooth effect on hover if desired */\n}\n\n.featureCard:hover .arrowIcon {\n  display: block; /* Show the arrow icon when the card is hovered */\n}\n\n.featureHeader {\n  display: flex;\n  align-items: center; /* Align icon and title vertically */\n  gap: 12px; /* Space between icon and title */\n  margin-bottom: 16px;\n}\n\n.featureIcon {\n  background-color: #e7e8ea;\n  border-radius: 8px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.featureTitle {\n  color: #1c1c1f;\n  font-size: 18px;\n  font-weight: 700;\n  display: inline-flex; /* Ensures the title and icon align horizontally */\n  align-items: center; /* Aligns the icon with the text */\n  gap: 8px; /* Adds space between the title and the icon */\n  margin: 0;\n}\n\n.featureDescription {\n  color: #1c1c1f;\n  font-size: 14px;\n /* margin-top: 8px; */\n  padding-left: 52px;\n}\n\n.footer {\n  background-color: #1e1e22;\n  padding: 88px 64px 16px;\n}\n\n.footerContent {\n  display: flex;\n  justify-content: space-between;\n}\n\n.footerColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.footerColumnTitle {\n  color: #bdf78a;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 1.26px;\n  text-transform: uppercase;\n  margin-bottom: 16px;\n}\n\n.footerLinkList {\n  list-style-type: none;\n  padding: 0;\n}\n\n.footerLink {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  line-height: 2;\n}\n\n.socialLinks {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.socialLink {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.socialIcon {\n  width: 17px;\n  height: 17px;\n}\n\n.footerDivider {\n  background-color: #bdf78a;\n  height: 1px;\n  margin: 48px 0;\n}\n\n.footerBottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.footerLogo {\n  width: 106px;\n}\n\n.copyright {\n  color: #fff;\n  font-size: 16px;\n}\n\n.visuallyHidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n@media (max-width: 991px) {\n\n  .containerFluid {\n    width: 100%;\n  }\n\n  .header {\n    padding: 16px 20px;\n  }\n\n  .hero {\n    padding: 100px 20px;\n  }\n\n  .heroTitle {\n    font-size: 40px;\n  }\n\n  .productCards {\n    flex-direction: column;\n    padding: 0 20px;\n  }\n\n  .gettingStarted {\n    padding: 100px 20px;\n  }\n\n  .stepsContainer {\n    flex-direction: column;\n  }\n\n  .resourcesSection {\n    padding: 100px 20px;\n  }\n\n  .resourcesGrid {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  .featureGrid {\n    padding: 60px 20px;\n  }\n\n\n\n  .footer {\n    padding: 60px 20px 16px;\n  }\n\n  .footerContent {\n    flex-wrap: wrap;\n    gap: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
